import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ItemTable from '../item-table'
import Pagination from "../pagination";
import { MagnifyingGlassIcon, PlusIcon } from '@heroicons/react/24/outline';
import { toast } from 'react-toastify';
import { BarFilters, BarFiltersIcon, BarFiltersLeft, Search, Sinc } from './styled';
import LazyLoading from '../../../../../components/lazy-loading';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import ModalCadLicenses from '../../modal-cad-licenses';
import { translations } from '../../../../../utils/language';
import ModalFeedDelete from '../modal-feed-delete';
import ModalFeedCompleted from '../../../../../components/tailwind/modal-feed-completed';




function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function Table(props) {
    const checkbox = useRef()
    const [checked, setChecked] = useState(false)
    const [indeterminate, setIndeterminate] = useState(false)
    const [selectedLicenses, setSelectedLicenses] = useState([])
    const dispatch = useDispatch()
    const [page, setpage] = useState(1)
    const [perPage, setperPage] = useState(40)
    const [search, setSearch] = useState("")

    const [dataLicenses, setDataLicenses] = useState([])
    const licenses = useSelector((state) => state.reducerLicenses);
    const [visibleModalCadLicenses, setVisibleModalCadLicenses] = useState(false)


    useEffect(() => {
        //console.log("licenses", licenses)
    }, [licenses])

    const handleClick = () => {
        if (checkbox.current) {
            checkbox.current.click();
        }
    };

    useEffect(() => {
        console.log("licenses", licenses?.data?.data)
        licenses?.data?.data?.length > 0 && setDataLicenses(licenses.data.data)
        licenses?.data?.data == undefined && setDataLicenses([])
    }, [licenses])

    useLayoutEffect(() => {
        const isIndeterminate = selectedLicenses.length > 0 && selectedLicenses.length < dataLicenses.length
        setChecked(dataLicenses.length == 0 || licenses.loading ? false : selectedLicenses.length === dataLicenses.length)
        setIndeterminate(isIndeterminate)
        checkbox.current.indeterminate = isIndeterminate
    }, [selectedLicenses])

    function toggleAll() {
        setSelectedLicenses(checked || indeterminate ? [] : dataLicenses)
        setChecked(!checked && !indeterminate)
        setIndeterminate(false)
    }

    const location = useLocation()
    const removeQueryParam = (param) => {
        const url = new URL(window.location);
        url.searchParams.delete(param);
        window.history.pushState({}, "", url);

        const url2 = window.location.href; // Obtém a URL atual
        const urlSemQuery = url2.split("?")[0];

        // Atualiza a URL no navegador sem recarregar a página
        window.history.replaceState(null, "", urlSemQuery);
    };


    const goSearch = () => {
        dispatch({ type: "SAGA_LIST_LICENSES", payload: { search: search, perPage: perPage, page: page }, });
        removeQueryParam("pageLicenses")
    }

    useEffect(() => { goSearch() }, [page,])


    const reducerDeleteLicenses = useSelector((state) => state.reducerDeleteLicenses);
    const language = useSelector((state) => state.reducerLanguage);


    useEffect(() => {
        console.log("testandooooooo", reducerDeleteLicenses)
        if (reducerDeleteLicenses.loading == false && reducerDeleteLicenses.error == false && reducerDeleteLicenses?.data?.length == 0) {

        } else {
            const id = "reducerDeleteLicenses"
            if (reducerDeleteLicenses.loading) {
                toast.loading(translations["Aguarde..."][language.data], { toastId: id })
            } else {
                if (reducerDeleteLicenses.error) toast.update(id, { render: "Erro ao tentar excluír.", type: "error", isLoading: false, hideProgressBar: false, autoClose: 3000, closeOnClick: true });
                else {
                    toast.update(id, { render: "Excluído com sucesso", type: "success", isLoading: false, hideProgressBar: false, autoClose: 2000, closeOnClick: true })
                    //props.setVisible(false)
                    goSearch()
                    dispatch({ type: "LICENSES_DELETE_RESET" })
                }
            }
        }
    }, [reducerDeleteLicenses])

    const [dataModalDeleteCompleted, setDataModalDeleteCompleted] = useState([])
    const [mediaLoadingId, setMediaLoadingId] = useState(null)
    const [visibleModalFeedDelete, setVisibleModalFeedDelete] = useState(false)
    const [visibleModalCompletedFeed, setVisibleModalCompletedFeed] = useState(false)

    const requestItems = async () => {
        console.log("selectedMedias", selectedLicenses)
        for (const item of selectedLicenses) {
            console.log("item =>", item)
            try {
                setMediaLoadingId(item.id)
                const token = JSON.parse(localStorage.getItem("depoimentos@login"))?.access_token.token;
                const url = `${process.env.REACT_APP_API_URL}/licenses/${item.id}`;
                const headers = new Headers({ 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' });
                const response = await fetch(url, { method: 'DELETE', headers: headers });
                //const result = await response.json();
                //console.log(`result:`, result);
                setDataModalDeleteCompleted(prevData => [...prevData, item.id]);
                setMediaLoadingId(null)
            } catch (error) {
                console.error(`Erro na requisição do item ${item.name}:`, error.message);
            }
        }

        setVisibleModalFeedDelete(false)
        setVisibleModalCompletedFeed(true)
    }

    const closeModal = () => {
        handleClick()

        setTimeout(() => {
            setVisibleModalCompletedFeed(false)
            goSearch()
            setDataModalDeleteCompleted([])
        }, 10);
    }

    return (
        licenses.loading ?
            <LazyLoading /> :
            <>
                <ModalCadLicenses goSearch={goSearch} visible={visibleModalCadLicenses} setVisible={setVisibleModalCadLicenses} />

                <ModalFeedDelete
                    setVisible={setVisibleModalFeedDelete}
                    visible={visibleModalFeedDelete}
                    selectedMedias={selectedLicenses}
                    dataModalDeleteCompleted={dataModalDeleteCompleted}
                    setDataModalDeleteCompleted={setDataModalDeleteCompleted}
                    mediaLoadingId={mediaLoadingId}
                    goSearch={goSearch}
                    handleClick={handleClick}
                />

                <ModalFeedCompleted
                    setVisible={setVisibleModalCompletedFeed}
                    visible={visibleModalCompletedFeed}
                    title={"Exclusão Completa"}
                    desc={"Excluímos todos os arquivos selecionados"}
                    close={closeModal}
                />
                <div className="px-4 sm:px-6 lg:px-8">
                    <div className="sm:flex sm:items-center">
                        <div className="sm:flex-auto">
                            <h1 className="text-base font-semibold leading-6 text-gray-900">{translations["page-licenses-title"][language.data]}</h1>
                            <p className="mt-2 text-sm text-gray-700">
                                {translations["page-licenses-description"][language.data]}
                            </p>
                        </div>


                        <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
                            <button
                                onClick={() => { setVisibleModalCadLicenses(true) }}
                                type="button"
                                className="inline-flex items-center gap-x-2 rounded-md bg-green-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            >
                                <PlusIcon aria-hidden="true" className="-ml-0.5 h-5 w-5" />
                                {"Cadastrar"}
                            </button>
                        </div>
                    </div>


                    <BarFilters style={{ paddingRight: "20px" }}>
                        <span style={{ display: "flex", justifyContent: "space-between" }}>
                            <BarFiltersLeft style={{ marginRight: "20px" }}>
                                <Search>
                                    <span>
                                        <MagnifyingGlassIcon style={{ width: "20px" }} />
                                    </span>
                                    <input onKeyPress={(e) => { e.key == "Enter" && goSearch() }} type='text' placeholder={"Pesquisar por nome"} value={search} onChange={(e) => { setSearch(e.target.value) }} />
                                </Search>
                            </BarFiltersLeft>

                        </span>

                    </BarFilters>

                    <div className="mt-0 flow-root">
                        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                                <div className="relative">
                                    {selectedLicenses.length > 0 && (
                                        <div className="absolute left-14 top-0 flex h-12 items-center space-x-3 bg-white sm:left-12">
                                            <button
                                                onClick={() => {
                                                    requestItems()
                                                    setVisibleModalFeedDelete(true)
                                                }}
                                                type="button"
                                                className="inline-flex items-center rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white"
                                            >
                                                {"Excluir"}
                                            </button>

                                        </div>
                                    )}
                                    <table className="min-w-full table-fixed divide-y divide-gray-300 bg-white">
                                        <thead>
                                            <tr>
                                                <th scope="col" className="relative px-7 sm:w-12 sm:px-6">
                                                    <input
                                                        type="checkbox"
                                                        className="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                                                        ref={checkbox}
                                                        checked={checked}
                                                        onChange={toggleAll}
                                                    />
                                                </th>
                                                <th scope="col" className="min-w-[12rem] py-3.5 pr-3 text-left text-sm font-semibold text-gray-900">
                                                    Data
                                                </th>

                                                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                    Nome
                                                </th>

                                                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                    <label style={{ display: "flex", justifyContent: "center" }}>Disponíveis</label>
                                                </th>

                                                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                    <label style={{ display: "flex", justifyContent: "center" }}>Enviados</label>
                                                </th>

                                                {/* <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                    <label style={{ display: "flex", justifyContent: "center" }}>Total</label>
                                                </th> */}


                                                <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-3">
                                                    <span className="sr-only">Edit</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-200 bg-white">
                                            {dataLicenses?.map((item) => (
                                                <ItemTable pageOrder={page} goSearch={goSearch} classNames={classNames} setSelectedOrders={setSelectedLicenses} selectedOrders={selectedLicenses} item={item} />
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Pagination setPage={setpage} />
            </>
    )
}
